import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { values, max, findIndex, each, concat, orderBy } from 'lodash';
import styles from './styles.css';
import NumberDisplay from '../../../../components/number-display';
import MoneyDisplay from '../../../../components/money-display';
import DateTimeDisplay from '../../../../components/date-time-display';
import StatsCell from './StatsCell';
import { getUser } from '../../../Auth/AuthReducer';

import {
  getPipelineLoading, getPipelineLoaded,
  getPipelineStats, getPipelineRankings, getPipelineOwnerStats,

  getConversionLoading, getConversionLoaded,
  getConversionStats, getConversionRankings, getConversionOwnerStats,

  getForecastLoading, getForecastLoaded,
  getForecastStats, getForecastRankings, getForecastOwnerStats,


  getCurrentGlobalRankingsLoading,
  getCurrentGlobalRankingsLoaded,
  getCurrentGlobalRankings,

} from '../../DashboardReducer';

function getPeriodRange(start, end) {
  let periodRange = null;
  if (start && end) {
    const periodStart = moment(start, 'YYYY-MM-DD');
    const periodEnd = moment(end, 'YYYY-MM-DD');
    if (periodStart.isValid() && periodEnd.isValid() && periodEnd.isSameOrAfter(periodStart)) {
      if (periodStart.isSame(periodEnd, 'week')) {
        periodRange = `Week of ${periodStart.format('MMM DD')}`;
      } else if (periodStart.isSame(periodEnd, 'month')) {
        periodRange = periodStart.format('MMMM');
      } else {
        periodRange = `${periodStart.format('MMM \'YY')} - ${periodEnd.format('MMM \'YY')}`;
      }
    }
  }
  return periodRange;
}

const PIPELINE_CELL = 'PIPELINE_CELL';
const PROJECTED_CELL = 'PROJECTED_CELL';
const FORECAST_CELL = 'FORECAST_CELL';

class CurrentStats extends Component {
  constructor() {
    super();
    this.state = {
      heights: {
        [PIPELINE_CELL]: 0,
        [PROJECTED_CELL]: 0,
        [FORECAST_CELL]: 0,
      },
      maxHeight: 0,
    };
  }
  handleCellHeightChange(type, height) {
    const { heights } = this.state;
    const newHeights = {
      ...heights,
      [type]: Math.ceil(height),
    };
    const maxHeight = max(values(newHeights));
    this.setState({
      heights: newHeights,
      maxHeight,
    });
  }

  renderDisplay(value, isMoney = false, withPlus = false) {
    if (value === null) {
      return <span>N/A</span>;
    }
    if (isMoney) {
      return <MoneyDisplay value={value} abbreviated precision={1} withPlus={withPlus} />;
    }
    return <NumberDisplay value={value} precision={0} withPlus={withPlus} />;
  }

  renderPipeline() {
    const {
      pipelineSince,
      pipelineLoading,
      pipelineLoaded,
      pipelineStats,
      pipelineRankings,
      myPipelineRanking,
      rankingsLoading,
      rankingsLoaded,
    } = this.props;
    const isLoading = pipelineLoading || !pipelineLoaded;
    const isRankingLoading = rankingsLoading || !rankingsLoaded;
    let pipelineSinceDisplay = null;
    if (pipelineSince === 'last-week') {
      pipelineSinceDisplay = 'Last Week';
    } else if (pipelineSince === 'last-month') {
      pipelineSinceDisplay = 'Last Month';
    } else if (pipelineSince === 'last-quarter') {
      pipelineSinceDisplay = 'Last Quarter';
    } else if (pipelineSince !== null) {
      const m = moment(pipelineSince, 'YYYY-MM-DD');
      if (m.isValid()) {
        pipelineSinceDisplay = (
          <DateTimeDisplay value={m} format="short" />
        );
      }
    }

    let count = null;
    let amount = null;
    let ids = [];

    let netChangeCount = null;
    let netChangeAmount = null;
    let netChangeIds = [];

    let netGrowthCount = null;
    let netGrowthAmount = null;
    let netGrowthIds = [];

    let newStartsCount = null;
    let newStartsAmount = null;
    let newStartsIds = [];

    let advancedCount = null;
    let advancedAmount = null;
    let advancedIds = [];

    if (!isLoading && pipelineStats) {
      ({ amount, count, ids } = pipelineStats);

      netChangeCount = (pipelineStats.netChangeIncreaseCount || 0) - (pipelineStats.netChangeDecreaseCount || 0);
      netChangeAmount = (pipelineStats.netChangeIncreaseAmount || 0) - (pipelineStats.netChangeDecreaseAmount || 0);
      netChangeIds = concat(pipelineStats.netChangeIncreaseIds, pipelineStats.netChangeDecreaseIds);

      netGrowthCount = (pipelineStats.netGrowthNewCount || 0) - (pipelineStats.netGrowthClosedCount || 0);
      netGrowthAmount = (pipelineStats.netGrowthNewAmount || 0) - (pipelineStats.netGrowthClosedAmount || 0);
      netGrowthIds = concat(pipelineStats.netGrowthNewIds, pipelineStats.netGrowthClosedIds);

      newStartsCount = pipelineStats.netGrowthNewCount || 0;
      newStartsAmount = pipelineStats.netGrowthNewAmount || 0;
      newStartsIds = pipelineStats.netGrowthNewIds || [];

      advancedCount = pipelineStats.netAdvancedCount || 0;
      advancedAmount = pipelineStats.netAdvancedAmount || 0;
      advancedIds = pipelineStats.netAdvancedIds || [];
    }

    let statsNumberClick = null;
    if (ids && ids.length > 0) {
      statsNumberClick = () => {
        this.props.handleSelectOpportunities(ids, 'pipeline');
      };
    }

    const rows = [
      {
        label: 'Net Change', count: netChangeCount, amount: netChangeAmount, ids: netChangeIds,
      },
      {
        label: 'Net Growth', count: netGrowthCount, amount: netGrowthAmount, ids: netGrowthIds,
      },
      {
        label: 'New Starts', count: newStartsCount, amount: newStartsAmount, ids: newStartsIds,
      },
      {
        label: 'Advanced', count: advancedCount, amount: advancedAmount, ids: advancedIds,
      },
    ];


    return (
      <StatsCell
        title="Pipeline"
        rank={myPipelineRanking}
        rankings={pipelineRankings}
        isRankingLoading={isRankingLoading}
        sumAmount={amount}
        sumCount={count}
        sumCountOnClick={statsNumberClick}
        sumAmountOnClick={statsNumberClick}
        minHeight={this.state.maxHeight}
        isLoading={isLoading}
        onHeightChange={(height) => {
          this.handleCellHeightChange(PIPELINE_CELL, height);
        }}
      >
        <table className={`table table-condensed ${styles.table}`}>
          <thead>
            <tr>
              <th>
                {pipelineSinceDisplay !== null &&
                  <span>Since {pipelineSinceDisplay}</span>
                }
              </th>
              <th className="text-right">Count</th>
              <th className="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              let countComp = this.renderDisplay(row.count, false, true);
              let amountComp = this.renderDisplay(row.amount, true, true);
              if (row.ids && row.ids.length > 0) {
                countComp = (
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.handleSelectOpportunities(row.ids, 'pipeline');
                    }}
                  >
                    {countComp}
                  </a>
                );
                amountComp = (
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.handleSelectOpportunities(row.ids, 'pipeline');
                    }}
                  >
                    {amountComp}
                  </a>
                );
              }
              return (
                <tr key={row.label}>
                  <td>{row.label}</td>
                  <td className="text-right">
                    {countComp}
                  </td>
                  <td className="text-right">
                    {amountComp}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </StatsCell>
    );
  }

  renderProjectedSales() {
    const {
      conversionLoading,
      conversionLoaded,
      conversionStats,
      conversionRakings,
      myConversionRanking,
      rankingsLoading,
      rankingsLoaded,
    } = this.props;
    const isLoading = conversionLoading || !conversionLoaded;
    const isRankingLoading = rankingsLoading || !rankingsLoaded;
    let amount = null;
    let earlyAmount = null;
    let lateAmount = null;
    if (!isLoading && conversionStats) {
      amount = conversionStats.totalProjectedSales || 0;
      earlyAmount = conversionStats.earlyProjectedSales || 0;
      lateAmount = conversionStats.lateProjectedSales || 0;
    }

    return (
      <StatsCell
        title="Projected Sales"
        isLoading={isLoading}
        rank={myConversionRanking}
        rankings={conversionRakings}
        isRankingLoading={isRankingLoading}
        sumAmount={amount}
        hideCount
        minHeight={this.state.maxHeight}
        onHeightChange={(height) => {
          this.handleCellHeightChange(PROJECTED_CELL, height);
        }}
      >
        <table className={`table table-condensed ${styles.table}`}>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th className="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Early Sales Stages</td>
              <td className="text-right">
                {this.renderDisplay(earlyAmount, true)}
              </td>
            </tr>
            <tr>
              <td>Late Sales Stages</td>
              <td className="text-right">
                {this.renderDisplay(lateAmount, true)}
              </td>
            </tr>
          </tbody>
        </table>
      </StatsCell>
    );
  }

  renderForecast() {
    const {
      period,
      forecastLoading,
      forecastLoaded,
      forecastStats,
      forecastRakings,
      myForecastRanking,
      rankingsLoading,
      rankingsLoaded,
    } = this.props;
    const isLoading = forecastLoading || !forecastLoaded;
    const isRankingLoading = rankingsLoading || !rankingsLoaded;
    const periodRange = getPeriodRange(...period);

    let amount = null;
    let count = null;
    const rows = [];
    if (!isLoading && forecastStats) {
      ({ count, amount } = forecastStats);
      if (forecastStats.won) {
        rows.push({
          type: 'won',
          label: `Won In ${periodRange}`,
          amount: forecastStats.won.amount,
          count: forecastStats.won.count,
          ids: forecastStats.won.ids || [],
        });
      }
      const { categories } = forecastStats;
      each(['Commit', 'Best Case', 'Pipeline'], (cat) => {
        const c = categories[cat];
        rows.push({
          type: cat,
          label: `In ${cat}`,
          amount: c ? c.amount : null,
          count: c ? c.count : null,
          ids: c ? c.ids : [],
        });
      });
    }

    let statsNumberClick = null;
    if (forecastStats && forecastStats.ids && forecastStats.ids.length > 0) {
      statsNumberClick = () => {
        this.props.handleSelectOpportunities(forecastStats.ids, 'forecast');
      };
    }

    return (
      <StatsCell
        title={`${periodRange} Forecast`}
        isLoading={isLoading}
        rank={myForecastRanking}
        rankings={forecastRakings}
        isRankingLoading={isRankingLoading}
        sumAmount={amount}
        sumCount={count}
        sumCountOnClick={statsNumberClick}
        sumAmountOnClick={statsNumberClick}
        minHeight={this.state.maxHeight}
        onHeightChange={(height) => {
          this.handleCellHeightChange(FORECAST_CELL, height);
        }}
      >
        <table className={`table table-condensed ${styles.table}`}>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th className="text-right">Count</th>
              <th className="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              let countComp = this.renderDisplay(row.count, false);
              let amountComp = this.renderDisplay(row.amount, true);
              if (row.ids && row.ids.length > 0) {
                countComp = (
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.handleSelectOpportunities(row.ids, 'forecast');
                    }}
                  >
                    {countComp}
                  </a>
                );
                amountComp = (
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.handleSelectOpportunities(row.ids, 'forecast');
                    }}
                  >
                    {amountComp}
                  </a>
                );
              }
              return (
                <tr key={row.type}>
                  <td>{row.label}</td>
                  <td className="text-right">
                    {countComp}
                  </td>
                  <td className="text-right">
                    {amountComp}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </StatsCell>
    );
  }

  render() {
    return (
      <div className={styles.stats}>
        {this.renderPipeline()}
        {this.renderProjectedSales()}
        {this.renderForecast()}
      </div>
    );
  }
}

CurrentStats.propTypes = {
  pipelineSince: PropTypes.string,
  period: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.instanceOf(moment), PropTypes.string])),
  pipelineLoading: PropTypes.bool,
  pipelineLoaded: PropTypes.bool,
  pipelineStats: PropTypes.shape({}),
  pipelineRankings: PropTypes.arrayOf(PropTypes.shape({})),
  myPipelineRanking: PropTypes.number,

  conversionLoading: PropTypes.bool,
  conversionLoaded: PropTypes.bool,
  conversionStats: PropTypes.shape({}),
  conversionRakings: PropTypes.arrayOf(PropTypes.shape({})),
  myConversionRanking: PropTypes.number,

  forecastLoading: PropTypes.bool,
  forecastLoaded: PropTypes.bool,
  forecastStats: PropTypes.shape({}),
  forecastRakings: PropTypes.arrayOf(PropTypes.shape({})),
  myForecastRanking: PropTypes.number,

  rankingsLoading: PropTypes.bool,
  rankingsLoaded: PropTypes.bool,

  handleSelectOpportunities: PropTypes.func,
};
CurrentStats.defaultProps = {
  pipelineSince: null,
  period: [null, null],
  pipelineLoading: true,
  pipelineLoaded: false,
  pipelineStats: null,

  pipelineRankings: [],
  myPipelineRanking: null,

  conversionLoading: false,
  conversionLoaded: false,
  conversionStats: null,

  conversionRakings: [],
  myConversionRanking: null,

  forecastLoading: false,
  forecastLoaded: false,
  forecastStats: null,
  forecastRakings: [],
  myForecastRanking: null,

  rankingsLoading: false,
  rankingsLoaded: false,

  handleSelectOpportunities: () => {},
};
CurrentStats.contextTypes = {
  router: PropTypes.shape({}),
};


// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const { shouldShowAllStats } = ownProps;

  const auth = getUser(state);
  const allRankings = getCurrentGlobalRankings(state) || [];
  const rankingsLoading = getCurrentGlobalRankingsLoading(state);
  const rankingsLoaded = getCurrentGlobalRankingsLoaded(state);
  const isRankingLoading = rankingsLoading || !rankingsLoaded;

  const pipelineRankings = orderBy(allRankings.map((owner) => ({ owner, amount: owner.pipeline_amount })), ['amount'], ['desc']);
  const conversionRakings = orderBy(allRankings.map((owner) => ({ owner, amount: owner.projected_amount })), ['amount'], ['desc']); 
  const forecastRakings = orderBy(allRankings.map((owner) => ({ owner, amount: owner.forecast_amount })), ['amount'], ['desc']); 

  let myPipelineRanking = null;
  let myConversionRanking = null;
  let myForecastRanking = null;

  if (auth.user_id && !isRankingLoading) {
    const myPipelineRankingIdx = findIndex(pipelineRankings, r => r.owner.user_id === auth.user_id);
    if (myPipelineRankingIdx >= 0) {
      myPipelineRanking = myPipelineRankingIdx + 1;
    }

    const myConversionIdx = findIndex(conversionRakings, r => r.owner.user_id === auth.user_id);
    if (myConversionIdx >= 0) {
      myConversionRanking = myConversionIdx + 1;
    }

    const myForecastIdx = findIndex(forecastRakings, r => r.owner.user_id === auth.user_id);
    if (myForecastIdx >= 0) {
      myForecastRanking = myForecastIdx + 1;
    }
  }

  let pipelineStats = null;
  let conversionStats = null;
  let forecastStats = null;

  if (shouldShowAllStats) {
    pipelineStats = getPipelineStats(state);
    conversionStats = getConversionStats(state);
    forecastStats = getForecastStats(state);
  } else if (auth.user_id) {
    pipelineStats = getPipelineOwnerStats(state)[auth.user_id];
    conversionStats = getConversionOwnerStats(state)[auth.user_id];
    forecastStats = getForecastOwnerStats(state)[auth.user_id];
  }


  return {
    pipelineLoading: getPipelineLoading(state),
    pipelineLoaded: getPipelineLoaded(state),
    pipelineStats,

    pipelineRankings,
    myPipelineRanking,

    conversionLoading: getConversionLoading(state),
    conversionLoaded: getConversionLoaded(state),
    conversionStats,

    conversionRakings,
    myConversionRanking,

    forecastLoading: getForecastLoading(state),
    forecastLoaded: getForecastLoaded(state),
    forecastStats,

    forecastRakings,
    myForecastRanking,

    rankingsLoading,
    rankingsLoaded,
  };
}

export default connect(mapStateToProps)(CurrentStats);
